"use client"
// PC 首页「运营方案摘要」区：solution_tabs 前 3 条摘要卡（服务端读库经 props 传入）
import React from 'react'
import { BlurFade } from './BlurFade'
import { homeDict, type HomeSection6Dict } from '@/lib/i18n/dicts/home'

// 运营方案摘要卡数据（page.tsx 由 solution_tabs 前 3 条本地化后组装）
export interface Section6SolutionItem {
    id: number
    name: string
    stepCount: number
    advantage: string
}

export interface Section6Props {
    dict?: HomeSection6Dict
    solutions?: Section6SolutionItem[]
}

export default function Section6({ dict = homeDict.zh.section6, solutions = [] }: Section6Props) {
    return (
        <main className="py-2 bg-slate-50">
            <div className=" max-w-7xl mx-auto px-4 text-gray-600 md:px-8">

                {/* 运营方案摘要：solution_tabs 前 3 条（名称 + 步骤数 + 优势），链接 /solutions */}
                {solutions.length > 0 && (
                    <BlurFade delay={0.05} inView>
                        <div className="my-10">
                            <div className="pb-5 border-b border-gray-200 sm:flex sm:items-center sm:justify-between">
                                <div>
                                    <p className="text-xs font-semibold tracking-widest text-indigo-600 uppercase">{dict.solutions.kicker}</p>
                                    <h3 className="mt-1 font-black text-lg leading-6 text-gray-900">{dict.solutions.heading}</h3>
                                </div>
                                <div className="mt-3 sm:mt-0 sm:ml-4">
                                    <a
                                        href='../solutions'
                                        type="button"
                                        className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg hover:shadow-indigo-500/30 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                    >
                                        {dict.solutions.viewAll}
                                    </a>
                                </div>
                            </div>
                            <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
                                {solutions.map((s) => (
                                    <a
                                        key={s.id}
                                        href='../solutions'
                                        className="group rounded-xl bg-white p-6 ring-1 ring-gray-200 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-indigo-500/10 hover:ring-indigo-300"
                                    >
                                        <div className="flex items-center justify-between gap-3">
                                            <h4 className="text-base font-bold text-gray-900 transition-colors duration-300 group-hover:text-indigo-700">{s.name}</h4>
                                            <span className="flex-shrink-0 rounded-full bg-indigo-50 px-2.5 py-0.5 text-xs font-medium text-indigo-600">
                                                {dict.solutions.stepsLabel.replace('{count}', String(s.stepCount))}
                                            </span>
                                        </div>
                                        {s.advantage && (
                                            <p className="mt-3 text-xs leading-5 text-gray-500">{s.advantage}</p>
                                        )}
                                    </a>
                                ))}
                            </div>
                        </div>
                    </BlurFade>
                )}

            </div>
        </main>
    )
}
